export { default } from './TableHead';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableHead/index.js
// module id = 363
// module chunks = 0